import { AmbassadorBulkUpdate } from '../../api/schemas/bulkUpdate';
import { SpaceBetween, Container, FormField, Icon, Button } from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';

export function AmbassadorBulkUpdateDisplay({ update }: { update: AmbassadorBulkUpdate | null }) {
  const { t } = useTranslation(['ambassadors', 'translation']);

  const totalEntries = update
    ? update?.result.num_added + update?.result.num_updated + update?.result.num_skipped
    : 0;

  return (
    <SpaceBetween direction="vertical" size="m">
      <Container>
        <FormField label={`${t('bulkUpdate.ambassadors.entries', { count: totalEntries })}`}>
          <div style={{ color: '#656871' }}>
            <SpaceBetween direction="vertical" size="xs">
              <div>
                <Icon
                  size="inherit"
                  className="bulk-upload-result-icon"
                  name="check"
                  variant="success"
                />
                <span style={{ verticalAlign: 'middle' }}>
                  {`${t('bulkUpdate.ambassadors.ambassadorsAdded', { count: update?.result.num_added ?? 0 })}`}
                </span>
              </div>
              <div>
                <Icon
                  size="inherit"
                  className="bulk-upload-result-icon"
                  name="check"
                  variant="success"
                />
                <span style={{ verticalAlign: 'middle' }}>
                  {`${t('bulkUpdate.ambassadors.ambassadorsUpdated', { count: update?.result.num_updated ?? 0 })}`}
                </span>
              </div>
              <div>
                <Icon
                  size="inherit"
                  className="bulk-upload-result-icon"
                  name="close"
                  variant="normal"
                />
                <span style={{ verticalAlign: 'middle' }}>
                  {`${t('bulkUpdate.ambassadors.ambassadorsSkipped', { count: update?.result.num_skipped ?? 0 })}`}
                </span>
              </div>
            </SpaceBetween>
          </div>
        </FormField>
      </Container>
      <div style={{ float: 'right' }}>
        <SpaceBetween direction="horizontal" size="s">
          <Button
            variant="normal"
            disabled={false}
            loading={false}
            onClick={() => {
              (async () => {
                console.log('nothing yet!');
              })();
            }}
          >
            {t('bulkUpdate.ambassadors.previous')}
          </Button>
          <Button
            variant="normal"
            disabled={false}
            loading={false}
            onClick={() => {
              (async () => {
                console.log('nothing yet!');
              })();
            }}
          >
            {t('bulkUpdate.ambassadors.updateDirectory')}
          </Button>
        </SpaceBetween>
      </div>
    </SpaceBetween>
  );
}
